import React, { Component } from 'react'
import { Layout, Menu, Row, Col, Dropdown, Icon } from 'antd'
import { Link } from 'react-router-dom'

import './style.css'
import logo from './images/logo.png'

const { Header } = Layout

class HeaderTmp extends Component {
  state = {}
  render() {
    const menu = (
      <Menu style={{ fontFamily: 'Kanit-ExtraBold' }}>
        <Menu.Item key="1">
          <Link to="/">All Event</Link>
        </Menu.Item>
        <Menu.Item key="2">
          <a target="_blank" rel="noopener noreferrer" href="https://followme.thai.run/">FollowMe</a>
        </Menu.Item>
        <Menu.Item key="3">
          <a target="_blank" rel="noopener noreferrer" href="https://photo.thai.run/">Photos</a>
        </Menu.Item>
      </Menu>
    )
    return (

      <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
        <Row type="flex" justify="center" >
          <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
            <Link to="/">
              <img src={logo} className="logo" alt="Logo" />
            </Link>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={['1']}
              style={{
 lineHeight: '64px', float: 'right', fontSize: '18px', fontFamily: 'Kanit-Midium',
}}
            >
              <Menu.Item key="1"> <Link to="/" > All Event </Link> </Menu.Item>
              <Menu.Item key="2"> <a href="https://followme.thai.run/" target="_blank" rel="noopener noreferrer" > FollowMe </a> </Menu.Item>

              <Menu.Item key="3"><a href="https://photo.thai.run/" target="_blank" rel="noopener noreferrer" > Photos </a></Menu.Item>
            </Menu>
            <div className="nav-icon">
              <Dropdown overlay={menu} trigger={['click']} >
                <Icon type="bars" style={{ color: 'rgb(241, 120, 57)' }} />
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Header>

    )
  }
}

export default HeaderTmp



// WEBPACK FOOTER //
// ./src/Template/HeaderTmp.js